/** The mockup's `paint()` (grants.html:555-565): all-label, the one value, or `first +N`. */
export function MultiSelectTriggerLabel(selected: readonly string[], allLabel: string): string {
    if (selected.length === 0) return allLabel;
    if (selected.length === 1) return selected[0];
    return `${selected[0]} +${selected.length - 1}`;
}
